import React from "react";

import { Body3, InternalLink } from "../../Typography";
import { SideNav, Bar } from "../styles";

function SideNavigation() {
  return (
    <SideNav>
      <Bar />
      <InternalLink to="/account/profile/" activeClassName="active">
        <Body3>My Account</Body3>
      </InternalLink>
      <InternalLink to="/account/rewards/" activeClassName="active">
        <Body3>My Rewards</Body3>
      </InternalLink>
      <InternalLink
        to="/account/notification-preferences/"
        activeClassName="active"
      >
        <Body3>Notification Preferences</Body3>
      </InternalLink>
    </SideNav>
  );
}

export default SideNavigation;
